import React from "react";
import "../../styles/CaseStudyOne/CaseStudiesHero.css";

const CaseStudiesHero = () => {
  return (
    <section id="case-studies-hero-one" className="case-studies-hero">
      <div className="hero-container">
        {/* Left Content */}
        <div className="hero-left">
          <h2 className="hero-subtitle">AI Call Tracking</h2>
          <h1 className="hero-title">Bullfrog Pool Tile Cleaning</h1>
          <p className="hero-description">
            Bullfrog Pool Tile Cleaning, serving the greater Phoenix area since
            2007, specializes in eco-friendly pool tile and Pebble Tec cleaning,
            acid washing, and pool draining. Using advanced, non-abrasive
            methods, they safely remove calcium deposits and stains, ensuring
            top-quality service and customer satisfaction.
          </p>
          <ul className="hero-kpi-list">
            <li className="kpi-item">
              <div className="case-study-checkmark-icon"></div> Cost Per Booked
              Appointment Decrease
            </li>
            <li className="kpi-item">
              <div className="case-study-checkmark-icon"></div> Successful Use
              of AI Integration
            </li>
            <li className="kpi-item">
              <div className="case-study-checkmark-icon"></div> PMAX Campaign
              Efficiency
            </li>
          </ul>
        </div>

        {/* Right Image */}
        <div className="hero-right">
          <div className="hero-image-container">
            <img
              src={require("../../assets/bullfrog-logo.png")} // Replace with your image path
              alt="Bullfrog Logo"
              className="hero-image"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default CaseStudiesHero;
